import { useState, useEffect, useContext } from "react"
import { useNavigate } from "react-router-dom";
import MenuPainel from "./MenuPainel";
import { AuthContext } from "./Authentication";
import { APIsHandlerContext } from "./APIs";
import Devices from "./Devices";
import "./styles/Painel.css"
import Fields from "./Fields";
import Events from "./Events";
import Mapa from "./Mapa";
import PainelHome from "./PainelHome";
import MapsManager from "./MapsManager";
import { ShapeContext } from './Shapefile';
import Veiculos from "./Veiculos";
import Implementos from "./Implementos";


const telaEnum = {
  devices: 0,
  painel_home: 1,
  campos: 2,
  eventos: 3,
  gerenciador_mapas: 4,
  mapa: 5,
  veiculos: 6,
  implementos: 7
}

export default function PainelControle() {

  const navigate = useNavigate();
  const [tela, setTela] = useState(0);
  const { getAuthUser, readShapefiles } = useContext(AuthContext);
  const { getUserDevicesAPI, getDevicesFieldsAPI, getFieldEventsAPI, getEventPolygonsAPI, getVehiclesAPI, getImplementsAPI } = useContext(APIsHandlerContext);
  const { importShp } = useContext(ShapeContext);
  const [ devices, setDevices ] = useState();
  const [ dispositivoEscolhido, setDispositivoEscolhido ] = useState();
  const [ fields, setFields ] = useState();
  const [ campoEscolhido, setCampoEscolhido ] = useState();
  const [ events, setEvents ] = useState();
  const [ vehicles, setVehicles ] = useState();
  const [ veiculoEscolhido, setVeiculoEscolhido ] = useState();
  const [ Implements, setImplements ] = useState();
  const [ eventoEscolhido, setEventoEscolhido ] = useState();
  const [ user, setUser ] = useState(null);
  const [ pontos, setPontos ] = useState(null);
  const [ poligonos, setPoligonos ] = useState(null);
  let shxBinary;
  let shpBinary;
  let dbfBinary;

  useEffect(() => {
    getAuthUser().then(resp => {
      if (resp == null) {
        console.log("Não tem usuario logado resp = ", resp);
        navigate("/");
        return;
      }
      //console.log("OK usuario ", resp.attributes.email, " logado");
      getUserDevicesAPI(resp.attributes.email)
      .then(res => {
        if(!res.ok) throw Error("Não conseguiu buscar");
        return res.json();
      })
      .then(data => {
        setDevices(data); 
        //console.log("painelcontrole.js useEffect getUserdevicesAPI then then ", data);
      })
      .catch(err => {
        console.log("painelcontrole.js useEffect getUserdevicesAPI catch ", err);
      });
    });    
  }, []);

  const handleClickMenu = (telaIndex) => {
    //console.log(`usuario = ${user}`);
    setTela(telaIndex);
  }

  const escolheDevice = ( device ) => {
    //console.log("Clicou no dispositivo ", device.deviceID);
    setDispositivoEscolhido(device);
    setTela(telaEnum.painel_home);
  } 

  const escolheCampo = ( campo ) => {
    console.log("Clicou no campo ", campo);
    setCampoEscolhido(campo)
    //busca os eventos deste campo
    getFieldEventsAPI(campo.campoUUID)
    .then(res => {
      if(!res.ok) throw Error("Não conseguiu buscar eventos deste campoUUID");
      return res.json();
    })
    .then(data => {
      setEvents(data); 
      console.log("painelcontrole.js getFieldEventsAPI then then ", data);
      setTela(telaEnum.eventos);
    })
    .catch(err => {
      console.log("painelcontrole.js getFieldEventsAPI catch ", err);
    });
  } 

  const escolheEvento = ( evento ) => {
    setEventoEscolhido(evento);
    console.log("Clicou no evento ", evento, " pertencente ao campo ", campoEscolhido);
    //carrega o shapefile do evento
    handleViewMap(evento.eventoUUID);
    return;
  }

  function escolheFuncao (funcao) {
    if (funcao === 0) {
      //clicou voltar devices
      setTela(telaEnum.devices);
    }
    if (funcao === 1) {
      //clicou voltar
      setTela(telaEnum.painel_home);
    }
    else if (funcao === 2) {
      //clicou trabalhos
      //busca os campos deste device
      getDevicesFieldsAPI(dispositivoEscolhido.deviceID)
      .then(res => {
        if(!res.ok) throw Error("Não conseguiu buscar campos deste deviceID");
        return res.json();
      })
      .then(data => {
        setFields(data); 
        console.log("painelcontrole.js getDevicesFieldsAPI then then ", data);      
        setTela(telaEnum.campos);
      })
      .catch(err => {
        console.log("painelcontrole.js getDevicesFieldsAPI catch ", err);
      });
    }
    else if (funcao === 3) {
      //clicou eventos
      //busca os eventos deste campo
      getFieldEventsAPI(campoEscolhido.campoUUID)
      .then(res => {
        if(!res.ok) throw Error("Não conseguiu buscar eventos deste campoUUID");
        return res.json();
      })
      .then(data => {
        setEvents(data); 
        console.log("painelcontrole.js getFieldEventsAPI then then ", data);
        setTela(telaEnum.eventos);
      })
      .catch(err => {
        console.log("painelcontrole.js getFieldEventsAPI catch ", err);
      });
    }
    else if (funcao === 4) {
      //clicou gerenciador de mapas
      setTela(telaEnum.gerenciador_mapas);
    }
    else if (funcao === 5) {
      //clicou veiculos
      getVehiclesAPI(dispositivoEscolhido.deviceID)
      .then(res => {
        if(!res.ok) throw Error("Não conseguiu buscar veiculos deste deviceID");
        return res.json();
      })
      .then(data => {
        setVehicles(data); 
        console.log("painelcontrole.js getVehiclesAPI then then ", data); 
        setTela(telaEnum.veiculos);
      })
      .catch(err => {
        console.log("painelcontrole.js getVEhiclesAPI catch ", err);
      });
    }
    else if (funcao === 6) {
      //clicou implementos
      getImplementsAPI(dispositivoEscolhido.deviceID)
      .then(res => {
        if(!res.ok) throw Error("Não conseguiu buscar implementos deste deviceID");
        return res.json();
      })
      .then(data => {
        setImplements(data); 
        console.log("painelcontrole.js getImplementsAPI then then ", data); 
        setTela(telaEnum.implementos);
      })
      .catch(err => {
        console.log("painelcontrole.js getImplementsAPI catch ", err);
      });
    }
  }

  function AbrirMapa () {
    setTela(telaEnum.mapa);
  }

  function abrirLocalizacao (veiculo) {
    console.log("Abrir localizacao do painelControle com veiculo escolhido", veiculo);
    setVeiculoEscolhido(veiculo);
    
    setTela(telaEnum.mapa);
  }

  const handleViewMap = (fileKey) => {
    readShapefiles(fileKey + ".shp")
    .then((signedURL) => {
      const url = URL.createObjectURL(signedURL.Body);
      const a = document.createElement('a');
      a.href = url;
      fetch(url)
      .then((response) => response.arrayBuffer())
      .then(data => {
        //console.log("data agora e ", data);
        shpBinary = data;
        console.log("shpBinary = ", shpBinary);
        readShapefiles(fileKey + ".shx")
        .then((signedURL) => {
          const url = URL.createObjectURL(signedURL.Body);
          const a = document.createElement('a');
          a.href = url;
          fetch(url)
          .then((response) => response.arrayBuffer())
          .then(data => {
            shxBinary = data;
            console.log("shxData = ", shxBinary);
            readShapefiles(fileKey + ".dbf")
            .then((signedURL) => {
              const url = URL.createObjectURL(signedURL.Body);
              fetch(url)
              .then((response) => response.arrayBuffer())
              .then(data => {
                dbfBinary = data;
                console.log("dbfData = ", dbfBinary);
                importShp(shpBinary, shxBinary, dbfBinary);
                AbrirMapa();
              });
            });
          });
          //console.log("handleViewMap data = ", data);
        });
      });
      //console.log("handleViewMap data = ", data);
    });
    
  }

  return (
  <div className="painel">
    <h1>Painel de controle</h1>
    <div className="painel-wrapper">          
        { /*<MenuPainel clickMenu={handleClickMenu}/> */}
        { (tela === telaEnum.devices) && devices &&  <Devices device={devices} setDevice={escolheDevice}/>}
        { (tela === telaEnum.painel_home) && <PainelHome funcao={escolheFuncao}/>}
        { (tela === telaEnum.gerenciador_mapas) && <MapsManager funcao={escolheFuncao} device={dispositivoEscolhido} AbrirMapa={AbrirMapa} limparEventoEscolhido={setEventoEscolhido} limparCampoEscolhido={setCampoEscolhido} limparVeiculoEscolhido={setVeiculoEscolhido}/>}
        { (tela === telaEnum.campos) && fields && <Fields fields={fields} setFields={escolheCampo} funcao={escolheFuncao} />}
        { (tela === telaEnum.eventos) && events && <Events funcao={escolheFuncao} eventos={events} setEvento={escolheEvento} campoEscolhido={campoEscolhido} limparVeiculoEscolhido={setVeiculoEscolhido}/>}
        { (tela === telaEnum.mapa) && <Mapa funcao={escolheFuncao} evento={eventoEscolhido} campo={campoEscolhido} veiculo={veiculoEscolhido}/>}
        { (tela === telaEnum.veiculos) && vehicles && <Veiculos funcao={escolheFuncao} veiculos={vehicles} abrirLocalizacao={abrirLocalizacao} limparCampoEscolhido={setCampoEscolhido}/> }
        { (tela === telaEnum.implementos) && Implements && <Implementos funcao={escolheFuncao} implementos={Implements} /> }
    </div>
  </div>
  )
}

/*

        { devices &&  <Devices device={devices} setDevice={escolheDevice}/>} */